import { RunElement } from '../../shared/run-element.js';
import { resolveSkinFromAncestors } from '../../shared/resolve-skin-name.js';
import * as defaultSkin from './skins/table-footer.default.js';
import * as wireframeSkin from './skins/table-footer.wireframe.js';

const _defaultSheet = new CSSStyleSheet();
_defaultSheet.replaceSync(defaultSkin.styles);

const _wireframeSheet = new CSSStyleSheet();
_wireframeSheet.replaceSync(wireframeSkin.styles || '');

class RunTableFooter extends RunElement {
  #rendering = false;

  connectedCallback() {
    super.connectedCallback();
    this.requestUpdate();
  }

  updated(changedProperties) {
    super.updated?.(changedProperties);
    if (this.#rendering) return;
    this.#rendering = true;
    try {
      const skin = this.#resolveSkin();
      if (skin === 'wireframe') {
        this.shadowRoot.adoptedStyleSheets = [_wireframeSheet];
        wireframeSkin.render(this);
      } else {
        this.shadowRoot.adoptedStyleSheets = [_defaultSheet];
        defaultSkin.render(this);
      }
    } finally {
      this.#rendering = false;
    }
  }

  #resolveSkin() {
    const s = this.getAttribute('skin');
    if (s) return s;
    return resolveSkinFromAncestors(this);
  }
}

if (!customElements.get('run-table-footer')) {
  customElements.define('run-table-footer', RunTableFooter);
}

export { RunTableFooter };
export default RunTableFooter;
